export const formatCurrency = (value: number): string => {
  const safe = Number.isFinite(value) ? value : 0;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(safe);
};

export const formatCompactCurrency = (value: number): string => {
  const safe = Number.isFinite(value) ? value : 0;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    notation: Math.abs(safe) >= 1000 ? 'compact' : 'standard',
    maximumFractionDigits: 1,
  }).format(safe);
};

export const formatDateTime = (value?: string | null): string => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(date);
};

export const formatDate = (value?: string | null): string => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'medium',
  }).format(date);
};

export const getGameTypeLabel = (value?: string): string => {
  switch (value) {
    case 'HOLD_EM':
      return 'Holdem';
    case 'OMAHA':
      return 'Omaha';
    case 'THREE_CARD':
      return 'Three Card';
    case 'OMAHA_HI_LO':
      return 'Omaha Hi-Lo';
    default:
      return value || '-';
  }
};

export const getMemberRoleLabel = (value?: string): string => {
  switch (value) {
    case 'OWNER':
      return 'Dono';
    case 'ADMIN':
      return 'Admin';
    case 'MOD':
      return 'Moderador';
    case 'MEMBER':
      return 'Membro';
    default:
      return value || '-';
  }
};
